/** Quote every field and neutralize spreadsheet formulas in user supplied text. */
export function csvContent(headers: string[], rows: unknown[][]): string {
  const cell = (value: unknown): string => {
    let text = value == null ? '' : String(value)
    if (/^[\s\uFEFF]*[=+\-@]/u.test(text)) text = `'${text}`
    return `"${text.replace(/"/g, '""')}"`
  }
  return '\uFEFF' + [headers, ...rows].map(row => row.map(cell).join(';')).join('\r\n')
}

export function downloadCsv(filename: string, headers: string[], rows: unknown[][]): void {
  const url = URL.createObjectURL(new Blob([csvContent(headers, rows)], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = filename.replace(/[/\\]/g, '-')
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
